import script from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"

import "./InvestSummary.vue?vue&type=style&index=0&id=101fe0a6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-101fe0a6"]])

export default __exports__